import React from 'react';
//import styles from './CreateAccount.module.sass'
//import cn from "classnames";
import { Link, useNavigate } from "react-router-dom";
import majesticHotelExteriorJpg from '../../../assets/images/properties/Majestic-Hotel/Majestic-Hotel-Exterior.jpg';
//import senseiLabsBuildingJpg from '../../../assets/images/Sensei-Labs/WEBoffice-building-2023-11-27-05-34-41-utc.jpg';
import { NAMES_CONSTANTS } from '../../../constants';

//const SenseiCreateAccount = () => {
const SenseiCreateAccount = (props) => {

    const navigate = useNavigate();

    //let userAccessToken = localStorage.getItem(localStorageKeyNameUserAccessToken);
    let userAccessToken = localStorage.getItem(NAMES_CONSTANTS.USER_ACCESS_TOKEN);
    console.debug('SenseiCreateAccount: userAccessToken = ', userAccessToken);

    return (
        <section
            className = 'sensei sensei-light sensei-building'
            /*
            style = {{
                //  backgroundImage: 'url(images/backgrounds/what-is-realsplit-background-275x183.jpg)'
                //backgroundImage: 'url(../../../assets/images/Sensei-Labs/WEBoffice-building-2023-11-27-05-34-41-utc.jpg)'
                backgroundImage: 'url(images/Sensei-Labs/WEBoffice-building-2023-11-27-05-34-41-utc.jpg)'
                //, backgroundPosition: 'left 0px bottom -100px'
                , backgroundPosition: 'center center'
                , backgroundRepeat: 'no-repeat'
                , backgroundSize: 'cover'
                //, maxWidth: 'var(--site-width)'
                //, maxWidth: '1500px'
                //, margin: 'auto'
                //paddingTop: '80px'
            }}
            */
            >

            <div
                //id = 'what-is-realsplit-container'
                //className = 'container'
                //className = 'flex-container max-width'
                className = 'site-max-width'
                style = {{
                    //maxWidth: 'var(--site-width)'
                    //maxWidth: '1350px'
                    //, flexWrap: 'wrap'
                    margin: 'auto'
                    //, marginLeft: '0'
                    //, textAlign: 'left'
                    //, width: '1500px'
                    //,  backgroundImage: 'url(images/backgrounds/what-is-realsplit-background.jpg)'
                    //, backgroundPosition: 'center'
                    //, backgroundRepeat: 'no-repeat'
                    //, backgroundImage: 'url(images/backgrounds/what-is-realsplit-background-275x183.jpg), url(images/backgrounds/what-is-realsplit-background-striped.jpg)'
                    //, backgroundImage: 'url(images/deals/Hillcrest/Hillcrest-pool.png), url(images/backgrounds/what-is-realsplit-background-striped.jpg)'
                    //, backgroundImage: 'url(images/properties/Majestic-Hotel/Majestic-Hotel-Exterior.jpg), url(images/backgrounds/what-is-realsplit-background-striped.jpg)'
                    //, backgroundImage: 'url(/assets/images/Sensei-Labs/WEBoffice-building-2023-11-27-05-34-41-utc.jpg)'
                    //, backgroundPosition: 'left 0px bottom 100px, right 150px bottom 0px'
                    //, backgroundRepeat: 'no-repeat, no-repeat'
                    //, backgroundSize: '650px, 400px'
                    //, paddingBottom: '250px'
                }}
                >

                <div
                    className = 'table site-max-width-inner own-commercial-income-producing'
                    /*
                    style = {{
                          margin: 'auto'
                        , marginLeft: '0'
                        , textAlign: 'left'
                        , maxWidth: '700px'
                        //, padding: '60px 0px 80px 0px'
                        , paddingTop: '60px'
                        , paddingBottom: '80px'
                        , paddingLeft: '20px'
                    }}
                    */
                    >

                    <h2
                        //className = { styles.sectionTitle }
                        className = 'baskervville-regular'
                        style = {{
                            //padding: '50px 0px 50px 0px'
                            textAlign: 'left'
                            /*
                            //display: 'inline'
                            //, textAlign: 'left'
                            //, margin: '0'
                            , padding: '20px 0px 30px 0px'
                            , color: 'var(--color-gray-800, #343A40)'
                            //, textAlign: 'center'
                            , fontFamily: 'Roboto Serif'
                            , fontSize: '68px'
                            , fontStyle: 'italic'
                            , fontWeight: '500'
                            , lineHeight: '120%'
                            //, marginRight: '50px'
                            */
                            //, lineHeight: '100%'
                            , wordSpacing: '-3px'
                        }}
                        >Own commercial income producing real estate.
                    </h2>

                    <p className = 'large'>
                        Build your portfolio and create passive income with RealSplit™
                        (Available to every accredited investor)
                    </p>

                    <p
                        style = {{
                            //padding: "10px 0px 0px 0px"
                            padding: "30px 0px"
                        }}>

                        {/*
                        <Link to="/search/all" target="_blank">
                        */}
                            <button
                                type = 'button'
                                //className = 'theme-success large'
                                className = 'theme-sensei'
                                onClick = { (event) => {
                                    if (!userAccessToken) {
                                        props.loginRegisterFunctions.clickRegister(event);
                                        return;
                                    } else {
                                        //window.open('https://realsplit.deal.tribexa.com/deal/create-investment', '_blank').focus();
                                        navigate('/search/all')
                                    }
                                }}
                                >Invest Now</button>
                        {/*
                        </Link>
                        */}
                    </p>
                </div>
            </div>
        </section>
    );
}

export default SenseiCreateAccount;
